<template>
  <div class="addCardPage">
    <job-header-simple></job-header-simple>
    <h1>编辑支付宝账号</h1>
    <header>
      请编辑<span>{{name}}</span>的支付宝账号
    </header>
    <van-cell-group>
        <van-field
            v-model="account"
            clearable
            label="账号"
            placeholder="请绑定本人的支付宝账号"
            maxlength="40"
        >
        </van-field>
    </van-cell-group>

    <div class="bottom">
      <van-button
        type="info"
        :loading="loading"
        size="large"
        round
        class="btn_theme"
        @click="handleEdit"
      >提交</van-button>
    </div>
    <van-popup v-model="isCityClicked" position="bottom">
      <van-picker
        title="城市选择"
        show-toolbar
        :columns="cityList"
        @confirm="handleCityConfirm"
        @cancel="isCityClicked = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { Field, Button, Cell, CellGroup, Toast, Popup, Picker } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import store from "@/store";
import { getAllCity } from "@/api/contract/taskRequest";
import api from "@/api/list";
export default {
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    jobHeaderSimple,
  },
  data() {
    return {
      id: "",
      account: "",
      idNumber: "",
      loading: false,
      isCityClicked: false,
      cityList: [],
      name: store.getters.jwtDecode.name,
      type: "",
      // isShow: false,
      ruleForm: {
        id : store.getters.jwtDecode.id,
        userName: store.getters.jwtDecode.name,
        account: "",
        bankName: "",
      },
    };
  },
  watch: {
    account: function () {
      if (this.account && typeof this.account != "undefined") {
        this.ruleForm.account = this.account;
      }
    },
  },
  created() {
    if (
      this.$route.query.type &&
      typeof this.$route.query.type != "undefined"
    ) {
      this.type = this.$route.query.type;
    }
    getAllCity().then((res) => {
      this.cityList = res.data.data;
    });
  },
  methods: {
    changeAccount() {
      if (
        !this.ruleForm.account ||
        typeof this.ruleForm.account == "undefined"
      ) {
        Toast.fail("请填写支付宝账号!");
          return false;
      }
    },
    handleEdit() {
      if (
        !this.ruleForm.account ||
        typeof this.ruleForm.account == "undefined"
      ) {
        Toast.fail("请填写支付宝账号!");
        return false;
      }
      this.loading = true;
      let params = {
        id: this.id,
        account: this.ruleForm.account,
      };
      api.alipayEdit(params, { method: "POST"})
      .then((res) => {
        if (res.data.status == "200") {
          Toast.success("已成功编辑");
          if (typeof this.$route.query.type != "undefined") {
            this.types = this.$route.query.type;
          }
          this.$router.push({
            path: "/card",
            query: {
              type: this.types,
              contractId: this.$route.query.obj,
            },
          });
        } else {
          Toast.fail(res.data.message);
        }
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        Toast.fail(error.response.message);
      });
    },
    handleCityConfirm(value, value2) {
      this.ruleForm.cityId = this.cityList[value2[0]].children[value2[1]].id;
      this.ruleForm.cityName = value.join("/");
      this.isCityClicked = false;
    },
  },
  mounted: function () {
    this.id = this.$route.query.id;
    this.account = this.$route.query.account;
    setTimeout(() => {
      this.changeAccount();
    }, 1000);
    document.getElementsByTagName("body")[0].className = "bg_f";
  },
  beforeDestroy: function () {
    document.body.removeAttribute("class", "bg_f");
  },
};
</script>

<style lang="less" scoped>
.addCardPage {
  h1 {
    font-size: 20px;
    color: #666;
    text-align: center;
    margin-bottom: 30px;
  }
  header {
    padding: 12px 20px;
    font-size: 14px;
    color: #999;

    span {
      color: #000;
      font-weight: 600;

      &.text-right {
        color: #ff976a;
        font-weight: normal;
      }
    }
  }

  /deep/ .van-field__label {
    width: 60px;
  }

  .showBig {
    position: absolute;
    left: 10px;
    bottom: 46px;
    background: #fff;
    border-radius: 10px;
    padding: 4px 12px;
    z-index: 9999;
    line-height: 30px;
    font-size: 20px;
    color: #444;
  }
}
.bottom {
  padding: 40px;
}
</style>


